import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { TariffsModuleService } from '../proxy/controlling/controllers/tariffs-module.service';

FieldBuilder.setNamespace('Controlling');

export const ZONETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ZoneType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ZoneType.Code')
    .required()
    .minLength(1)
    .maxLength(25)
    .build(),
  FieldBuilder
    .text('description', 'Entity.ZoneType.Description')
    .minLength(1)
    .maxLength(255)
    .build(),
  FieldBuilder
    .foreignKey('tariffsModuleId', 'Entity.TariffsModule', TariffsModuleService)
    .displayFromNested('tariffsModule.name')
    .sortBy('tariffsModule.name')
    .build(),
];

export const ZONETYPE_CONFIG = {
  entityName: 'ZoneType',
  localizationKey: 'Controlling::Entity.ZoneType',
  fields: ZONETYPE_FIELDS,
  permission: 'ControllingLiquidations.ZoneTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
